module.exports = __webpack_public_path__ + "6ca60ab9b0197d598bea3dac63419886.pdf";